import { jsx as r } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import n from "classnames";
import { useState as g, useMemo as k, useCallback as T, useRef as i, useEffect as B } from "../../../external/preact/hooks/dist/hooks.module.js";
import { useClickOutside as F } from "../../../hooks/element/useClickOutside.js";
import P from "../../../core/Context/useCoreContext.js";
import H from "../SVGIcons/ChevronUp.js";
import V from "../SVGIcons/ChevronDown.js";
/* empty css                    */
import { BASE_CLASS as Y, CONTAINER_CLASS as f, CONTAINER_BUTTON_CLASS as x, CONTAINER_FILLED_CLASS as C, CONTAINER_OVERLAY_ID as u, CONTENT_CLASS as A, CONTENT_EXPANDABLE_CLASS as I, CHEVRON_CLASS as v, CONTAINER_OVERLAY_CLASS as w, CONTAINER_HIDDEN_CLASS as U, CONTAINER_IN_FLOW_CLASS as j, CARD_HEIGHT_PROPERTY as b } from "./constants.js";
import { Fragment as q } from "../../../external/preact/dist/preact.module.js";
import y from "../BaseButton/BaseButton.js";
const re = ({ renderHeader: c, children: O, filled: l, fullWidth: S, inFlow: _, ...d }) => {
  const { i18n: E } = P(), [e, R] = g(!1), a = k(() => _ === !0, [_]), o = T(() => R((s) => !s), [R]), p = i(null), h = i(a), m = i(!1), L = i(e), N = F(
    void 0,
    T(() => {
      e && (o(), m.current = !0);
    }, [e, o])
  ), D = (s) => {
    var t;
    s && (a ? (!e || h.current !== a) && s.style.setProperty(b, `${((t = p.current) == null ? void 0 : t.offsetHeight) || 0}px`) : e || s.style.removeProperty(b), h.current = a);
  };
  return B(() => {
    var s, t;
    e ? (s = N.current) == null || s.focus() : (L.current !== e && !m.current && ((t = p.current) == null || t.focus()), m.current = !1), L.current = e;
  }, [e, N]), /* @__PURE__ */ r("div", { ref: D, className: Y, children: O ? /* @__PURE__ */ r(q, { children: [
    /* @__PURE__ */ r(
      y,
      {
        className: n(f, x, { [C]: l }),
        disabled: e,
        fullWidth: S,
        "aria-controls": u,
        "aria-expanded": e,
        "aria-hidden": e,
        onClick: o,
        ref: p,
        "data-testid": "expand-button",
        ...d,
        children: [
          /* @__PURE__ */ r("span", { className: "adyen-pe-sr-only", children: E.get("expandableCard.expand") }),
          /* @__PURE__ */ r("div", { className: n(A, I), children: c }),
          /* @__PURE__ */ r("div", { className: v, children: /* @__PURE__ */ r(V, { role: "presentation" }) })
        ]
      }
    ),
    /* @__PURE__ */ r(
      y,
      {
        id: u,
        className: n(f, x, w, {
          [C]: l,
          [U]: !e,
          [j]: a
        }),
        disabled: !e,
        fullWidth: S,
        "aria-controls": u,
        "aria-expanded": e,
        "aria-hidden": !e,
        onClick: o,
        ref: N,
        "data-testid": "collapse-button",
        ...d,
        children: [
          /* @__PURE__ */ r("span", { className: "adyen-pe-sr-only", children: E.get("expandableCard.collapse") }),
          /* @__PURE__ */ r("div", { className: n(A, I), children: [
            c,
            /* @__PURE__ */ r("div", { children: O })
          ] }),
          /* @__PURE__ */ r("div", { className: v, children: /* @__PURE__ */ r(H, { role: "presentation" }) })
        ]
      }
    )
  ] }) : /* @__PURE__ */ r("div", { className: n(f, { [C]: l }), ...d, children: /* @__PURE__ */ r("div", { className: A, children: c }) }) });
};
export {
  re as default
};
